import React, { Component } from 'react';

class RequestToJoinOrgSuccessMessageModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.showRequestToJoinOrgSuccessMessageModal !== this.props.showRequestToJoinOrgSuccessMessageModal){
			if(this.props.showRequestToJoinOrgSuccessMessageModal) {
				this.joinOrgSuccessMessageModalOpen.click();;
				this.props.closeRequestToJoinOrgSuccessMessageModal();
			}
		}
	}

	render () {
		return (
          <div>
          <input type="hidden" ref={elem => this.joinOrgSuccessMessageModalOpen = elem} id="JoinOrgSuccessMessageModalOpen" data-bs-toggle="modal" data-bs-target="#JoinOrgSuccessMessageModal"/>
  			<div className="modal fade" id="JoinOrgSuccessMessageModal" tabIndex="-1" role="dialog" aria-labelledby="JoinOrgSuccessMessageModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                 <div className="modal-content">
                   <div className="modal-header">FirstNet Developer Program</div>
                   <div className="modal-body">
                    Your request to join this organization/company has been submitted.
					<br/>
					<b>Keep an eye on your inbox.</b>
					<br/>
					the administrator for your organization/company must now review your request. Upon
					approval, you will receive a confirmation email. If the organization/company has AT&T API
					Platform access, then so do you!
                   </div>
                   <div className="modal-footer">
                   	<button className='btn btn-primary' data-bs-dismiss="modal">
           				OK
           			</button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
		)
	}
}

export default RequestToJoinOrgSuccessMessageModal;



// WEBPACK FOOTER //
// ./src/manageMyAccount/modals/RequestToJoinOrgSuccessMessageModal.js